import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import StyledPatchFavoriteButton from "./StyledPatchFavoriteButton";
import StyledPatchPointsBadge from "./StyledPatchPointsBadge";
import Slider from "./Slider";
import GradientCard from "./gradients/GradientCard";
import { errorMessages } from "../data/error-messages";

const getPatchPaddingScale = (patch) => {
  const max = Math.max(patch.height, patch.width);
  if (max >= 6.5) {
    return 0;
  }
  if (max < 6.5 && max >= 5.6) {
    return 1;
  }
  if (max < 5.6 && max >= 3.6) {
    return 2;
  }
  if (max < 3.6 && max >= 2.5) {
    return 3;
  }
  if (max < 2.5 && max >= 1.76) {
    return 4;
  }
  if (max < 1.76) {
    return 5;
  }
};

const PatchesSlider = ({
  patchesLoading,
  filteredPatches,
  filterValues,
  selectedTab,
  favoritePatches,
  sliderConfig,
  handleFavoritePatch,
}) => {
  return (
    <Box sx={{ padding: "10px 20px" }}>
      <Slider config={sliderConfig}>
        {(patchesLoading ? [{}] : [...filteredPatches]).map((patch, index) => (
          <div key={index} style={{ position: "relative" }}>
            <GradientCard
              variant="square"
              sx={{
                "& > .MuiCard-root": {
                  padding: `${getPatchPaddingScale(patch) * 5}%`,
                },
              }}
            >
              {patchesLoading && <CircularProgress />}
              {!patchesLoading && (
                <img
                  loading="lazy"
                  className="draggable"
                  src={patch.src}
                  style={{
                    maxHeight: "100%",
                    cursor: "move",
                    maxWidth: "65px",
                  }}
                  data-patch={JSON.stringify(patch)}
                  draggable={false}
                />
              )}
            </GradientCard>
            <StyledPatchFavoriteButton onClick={() => handleFavoritePatch(patch)}>
              {favoritePatches.some((e) => e.id === patch.id) ? (
                <FavoriteIcon htmlColor="#3982B8" />
              ) : (
                <FavoriteBorderIcon />
              )}
            </StyledPatchFavoriteButton>
            <StyledPatchPointsBadge>{patch.points}</StyledPatchPointsBadge>
          </div>
        ))}
      </Slider>
      {!patchesLoading && !filteredPatches.length && !!filterValues.length && selectedTab >= 1 && (
        <Typography sx={{ paddingBlock: "16px" }}>{errorMessages.PATCHES_EMPTY}</Typography>
      )}
      {!patchesLoading && !filteredPatches.length && selectedTab === 0 && (
        <Typography sx={{ paddingBlock: "16px" }}>{errorMessages.FAVORITES_EMPTY}</Typography>
      )}
    </Box>
  );
};

export default PatchesSlider;
